import React from 'react';
import HoverStore from '../store/hoverStore';
import { findIndex } from 'underscore';
import clone from 'clone';
const $ = jQuery;

class MapBlock extends React.Component {
  constructor(props) {
    super(props);
    this.displayName = 'MapBlock';

    this.setMarkers = this.setMarkers.bind(this);
    this.closeAllInfoWindow = this.closeAllInfoWindow.bind(this);
    this.handleGeolocation = this.handleGeolocation.bind(this);
    this.browserGeolocationSuccess = this.browserGeolocationSuccess.bind(this);
    this.browserGeolocationFail = this.browserGeolocationFail.bind(this);
    this.tryAPIGeolocation = this.tryAPIGeolocation.bind(this);
    this.markers = [];
    this.infobox = [];
  }
  componentDidMount() {
    const targetMap = (document.getElementById('reactiveMap'));
    const zoom = this.props.block.hasOwnProperty('zoom') ? parseInt(this.props.block.zoom, 10) : 3;
    this.zoom = zoom;
    if ($('#reactiveMap')) {
      window.reactiveMap = new google.maps.Map(targetMap, {
        zoom,
        center: new google.maps.LatLng(47.2532, -37.415),
        scrollwheel: API.hasOwnProperty('isMobile') && parseInt(API['isMobile'], 10) === 1 ? false : true,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
      });
      const input = (document.getElementById('myMapGeolocation'));
      window.reactiveMap.controls[google.maps.ControlPosition.TOP_LEFT].push(input);
    }

    this.setMarkers(this.props.previewOption.data);
    HoverStore.listen(this.hoverMarker.bind(this));
  }
  componentWillReceiveProps(nextProps) {
    this.setMarkers(nextProps.previewOption.data);
  }

  setMarkers(locations, geolocation) {
    const allLayout = clone(this.props.allLayout);
    let markerIcon = 'default';
    let markerTemplate = 'default';
    const mapIndex = findIndex(allLayout, { type: 'map' });
    if (mapIndex !== -1) {
      if (allLayout[mapIndex].hasOwnProperty('markerIcon')) {
        markerIcon = allLayout[mapIndex]['markerIcon'];
      }
      if (allLayout[mapIndex].hasOwnProperty('markerTemplate')) {
        markerTemplate = allLayout[mapIndex]['markerTemplate'];
      }
    }

    const map = window.reactiveMap;
    const markerBounds = new google.maps.LatLngBounds();
    if (this.markers.length) {
      for (let i = this.markers.length - 1; i >= 0; i--) {
        this.markers[i].setMap(null);
      }
      this.markers = [];
      this.infobox = [];
      if (this.markerCluster !== undefined) {
        this.markerCluster.clearMarkers();
      }
    }

    locations.forEach((location) => {
      if (!location.meta.hasOwnProperty('latitude')) {
        return;
      }
      if (location.meta.latitude && location.meta.longitude) {
        const myLatLng = new google.maps.LatLng(location.meta.latitude, location.meta.longitude);
        markerBounds.extend(myLatLng);
        const marker = new RichMarker({
          position: myLatLng,
          map,
          ID: location.ID,
          content: ReactiveMarkerIcon[markerIcon](location), // need to add theme support
        });
        const content = ReactiveMarkerTemplate[markerTemplate](location); // need to add theme support
        const infowindow = new google.maps.InfoWindow({ content, position: myLatLng });
        this.infobox.push(infowindow);
        marker.addListener('click', () => {
          infowindow.close();
          infowindow.open(map, marker);
          const iwOuter = $('.gm-style-iw');
          const iwBackground = iwOuter.prev();
          iwBackground.children(':nth-child(2)').css({ 'display': 'none' });
          iwBackground.children(':nth-child(4)').css({ 'display': 'none' });
          iwBackground.css({ 'display': 'none' });
          const iwCloseBtn = iwOuter.next();
          iwCloseBtn.css({ opacity: '1', right: '57px', top: '25px' });
        });
        this.markers.push(marker);
      }
    });
    // for geolocation purpose
    if (geolocation !== undefined) {
      const temp = {};
      temp.post_title = 'My Current Location';
      const myLatLng = new google.maps.LatLng(geolocation.latitude, geolocation.longitude);
      markerBounds.extend(myLatLng);
      const marker = new google.maps.Marker({
        position: myLatLng,
        map,
        content: '<div class="marker-info">My Location</div>',
      });
      const content = ReactiveMarkerTemplate.default(temp);
      const infowindow = new google.maps.InfoWindow({ content });
      marker.addListener('click', () => {
        infowindow.open(map, marker);
      });
      this.markers.push(marker);
      infowindow.open(map, marker);
    }

    this.markerCluster = new MarkerClusterer(map, this.markers);
    map.fitBounds(markerBounds);
  }
  closeAllInfoWindow() {
    this.infobox.forEach((info) => {
      info.close();
    });
  }

  hoverMarker(post) {
    if (post.hide) {
      this.closeAllInfoWindow();
    } else {
      this.closeAllInfoWindow();
      const findMarkerIndex = findIndex(this.markers, { ID: post.ID });
      if (findMarkerIndex !== -1) {
        const marker = this.markers[findMarkerIndex];
        google.maps.event.trigger(marker, 'click');
      }
    }
  }

  browserGeolocationSuccess(position) {
    const geoData = {};
    geoData['latitude'] = position.coords.latitude;
    geoData['longitude'] = position.coords.longitude;
    this.setMarkers(this.props.previewOption.data, geoData);
  }

  browserGeolocationFail(error) {
    switch (error.code) {
      case error.TIMEOUT:
        console.log('Browser geolocation error !\n\nTimeout.');
        break;
      case error.PERMISSION_DENIED:
        if (error.message.indexOf('Only secure origins are allowed') === 0) {
          this.tryAPIGeolocation();
        }
        break;
      case error.POSITION_UNAVAILABLE:
        console.log('Browser geolocation error !\n\nPosition unavailable.');
        break;
      default:
        break;
    }
  }

  tryAPIGeolocation() {
    const self = this;
    jQuery.post('https://www.googleapis.com/geolocation/v1/geolocate?key=' + API.googlemap_key, (success) => {
      self.browserGeolocationSuccess({ coords: { latitude: success.location.lat, longitude: success.location.lng } });
    })
    .fail((err) => {
      console.log('API Geolocation error! \n\n' + err);
    });
  }
  handleGeolocation(event) {
    event.preventDefault();
    window.navigator.geolocation.getCurrentPosition(
      this.browserGeolocationSuccess,
      this.browserGeolocationFail,
      { maximumAge: 50000, timeout: 20000, enableHighAccuracy: true },
    );
  }

  render() {
    const { settingsData } = this.props;
    const mapStyle = {
      width: '100%',
      height: this.props.block.hight ? parseInt(this.props.block.hight, 10) : '500px',
    };
    const ThemeComponent = window.ReactiveTheme[settingsData.theme];
    const ifOpen = this.props.isToggle ? 'active' + ' ' + 'rq-map-container' : 'toggle-option-map';
    return (<div className={ifOpen}>
      { ThemeComponent && <ThemeComponent.map styles={mapStyle} /> }
      <button type="button" className="map-location-button" id="myMapGeolocation" onClick={this.handleGeolocation}>{API.LANG.MAP_YOUR_LOC}</button>
    </div>);
  }
}

MapBlock.propTypes = {
  block: React.PropTypes.object,
  settingsData: React.PropTypes.object,
  previewOption: React.PropTypes.object,
  isToggle: React.PropTypes.bool,
  'allLayout': React.PropTypes.array,
};

export default MapBlock;



/** WEBPACK FOOTER **
 ** ./assets/src/frontend/preview/block/mapBlock.js
 **/